/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetFleetsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetFleetsQuery = {
  __typename?: 'Query',
  fleets?: {
    __typename?: 'FleetPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Fleet',
      id: number,
      externalId?: string | null,
      description: string,
      ships?: Array<{
        __typename?: 'Ship',
        id: number,
        name: string
      }> | null
    }>
  } | null
};

export type GetFleetsForSelectQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetFleetsForSelectQuery = {
  __typename?: 'Query',
  fleets?: {
    __typename?: 'FleetPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Fleet',
      id: number,
      description: string
    }>
  } | null
};

export type GetFleetQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetFleetQuery = {
  __typename?: 'Query',
  fleet?: {
    __typename?: 'Fleet',
    id: number,
    externalId?: string | null,
    description: string,
    ships?: Array<{
      __typename?: 'Ship',
      id: number,
      name: string
    }> | null
  } | null
};

export type GetFleetsByUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFleetsByUserQuery = {
  __typename?: 'Query',
  fleetsByUser?: Array<{
    __typename?: 'Fleet',
    id: number,
    description: string,
    activeFleet: boolean
  }> | null
};


export const GetFleetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFleets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fleets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fleet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fleet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fleet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetFleetsQuery, GetFleetsQueryVariables>;
export const GetFleetsForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFleetsForSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fleets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]} as unknown as DocumentNode<GetFleetsForSelectQuery, GetFleetsForSelectQueryVariables>;
export const GetFleetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFleet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fleet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fleet"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fleet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fleet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetFleetQuery, GetFleetQueryVariables>;
export const GetFleetsByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFleetsByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fleetsByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"activeFleet"}}]}}]}}]} as unknown as DocumentNode<GetFleetsByUserQuery, GetFleetsByUserQueryVariables>;